import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PhpackagingmaterialEditFormImpl from './PhpackagingmaterialEditFormImpl';
import PhpackagingmaterialList from './PhpackagingmaterialList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PhpackagingmaterialListView from './PhpackagingmaterialListView'


export default function PhpackagingmaterialDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.phpackagingmaterialDashboard);
  const [ phpackagingmaterialId, setPhpackagingmaterialId] = React.useState('');
  const [reloadPhpackagingmaterialList, setReloadPhpackagingmaterialList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PhpackagingmaterialEditFormImpl 
            setReloadPhpackagingmaterialList={setReloadPhpackagingmaterialList}
            phpackagingmaterialId={phpackagingmaterialId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PhpackagingmaterialListView 
                      setPhpackagingmaterialId = {setPhpackagingmaterialId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
